import React, { useState, useEffect } from "react";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";
import { errorToast, successToast } from "./common/showtoast";

const Buypackage = (props) => {

  const [memberid, setMemberId] = useState("");
  const [membername, setMemberName] = useState("");
  const [selforothers, setSelfOrOthers] = useState("self");
  const [packageData, setPackageData] = useState([]);
  const [code, setCode] = useState("");

  useEffect(() => {
    if (props.match.params && props.match.params.step) {
      setSelfOrOthers(props.match.params.step === "team" ? "Others" : "self");
    }
    getJoiningList();
  }, [props.match.params]);

  const getJoiningList = async () => {
    try {
      let res = await ApiRequest("repurchase_product_list.asp", "GET", null, { Authorization: localStorage.getItem("token") });
      console.log(res);
      if (res.status === "error") {
        errorToast(res.message);
        if (res.message === "Session Expired") {
          localStorage.clear();
          props.history.push("/login");
        }
        return;
      }
      setPackageData(res.items);
    } catch (error) {
      console.error("Error fetching repurchase product list:", error);
    }
  };

  const getName = async () => {
    if (!memberid) {
      return;
    }
    let jsoninput = {
      memberid: memberid
    };
    try {
      let res = await ApiRequest("getname.asp", "POST", jsoninput, { Authorization: localStorage.getItem("token") });
      if (res.status === "error") {
        errorToast(res.message);
        if (res.message === "Session Expired") {
          localStorage.clear();
          props.history.push("/login");
        }
        return;
      }
      setMemberName(res.fullname);
    } catch (error) {
      console.error("Error fetching member name:", error);
    }
  };

  const buyContractConfirm = async (json) => {
    try {
      let res = await ApiRequest("repurchase.asp", "POST", json, { Authorization: localStorage.getItem("token") });
      console.log(res);
      if (res.status === "error") {
        errorToast(res.message);
        if (res.message === "Session Expired") {
          localStorage.clear();
          props.history.push("/login");
        }
        return;
      }
      successToast(res.message);
      setMemberName("");
      setMemberId("");
    } catch (error) {
      console.error("Error confirming purchase:", error);
    }
  };

  return (
    <div>
      <PageHeader title="Repurchase" />
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
          <div className="card overflow-hidden dash1-card border-0 ">
            <div className="card-body" style={{ justifyContent: "center" }}>
              <h5 className=" mt-3 mb-3">Repurchase</h5>
              <div className="search-element row mb-5" style={{ display: selforothers === "Others" ? "flex" : "none" }}>
                <div className="input-container">
                  <i className="las la-user-circle inputicon"></i>
                  <input
                    type="text"
                    className="form-control col-lg-4"
                    onBlur={getName}
                    placeholder="Memberid"
                    aria-label="memberid"
                    tabIndex="1"
                    onChange={(e) => setMemberId(e.target.value)}
                    value={memberid}
                  />
                </div>
              </div>

              <div className="search-element row mb-5" style={{ display: selforothers === "Others" ? "flex" : "none" }}>
                <div className="input-container">
                  <i className="las la-user inputicon"></i>
                  <input
                    type="text"
                    className="form-control col-lg-4"
                    placeholder="membername"
                    aria-label="membername"
                    tabIndex="1"
                    readOnly
                    value={membername}
                  />
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>MRP</th>
                        <th>PV</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {packageData.length <= 0 ? (
                        <tr>
                          <td colSpan="6">No Details Found</td>
                        </tr>
                      ) : (
                        packageData.map((item, index) => (
                          <tr key={index}>
                            <td className="tabletd">{index + 1}</td>
                            <td>{item.product_name}</td>
                            <td>{item.Price}</td>
                            <td>{item.mrp}</td>
                            <td>{item.PV}</td>
                            <td>
                              <input
                                name="package"
                                type="radio"
                                onChange={(e) => setCode(e.target.value)}
                                value={item.code}
                                checked={code === item.code}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                      <tr>
                        <td colSpan="6">
                          <div style={{ justifyContent: "center", display: "grid" }}>
                            <button
                              className="btn primebtn"
                              onClick={async () => {
                                if (!memberid && selforothers === "Others") {
                                  errorToast("Enter valid memberid");
                                  return;
                                } else if (!code) {
                                  errorToast("Please Select Product");
                                  return;
                                }
                                let json = {
                                  toupuser: selforothers === "Others" ? memberid : localStorage.getItem("username"),
                                  productcode: code
                                };
                                await buyContractConfirm(json);
                              }}
                            >
                              Purchase
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Buypackage;
